import { VideoProject } from "@/services/bedrock";

export function statusMenuActionLabel(event: VideoProject.Event): string {
  switch (event) {
    case VideoProject.Event.START_EDITING:
      return "Start editing";
    case VideoProject.Event.STOP_EDITING:
      return "Stop editing";
    case VideoProject.Event.RETURN_TO_EDITING:
      return "Return to editing";
    case VideoProject.Event.SUBMIT_FOR_QA_REVIEW:
      return "Submit for QA Review";
    case VideoProject.Event.STOP_QA_REVIEW:
      return "Stop QA review";
    case VideoProject.Event.START_QA_REVIEW:
      return "Start QA review";
    case VideoProject.Event.COMPLETE:
    case VideoProject.Event.APPROVE_QA:
      return "Send to client";
    case VideoProject.Event.REJECT_QA:
      return "Send back for edits";
    case VideoProject.Event.REOPEN_EDITING:
      return "Re-open";
    default:
      return "Update status";
  }
}
